// Complete service-management scope for a customer organization, never platform roles.
export const fullOrganizationManagerPermissions = ["products.read", "events.read", "events.manage"] as const;
